import { atomFamily } from 'recoil';

export const triggerState = atomFamily({
  key: 'trigger',
  default: Date.now()
});
